// types
import { IAllocationType } from "@defs/Utilities";
import { UserSandboxAccess } from "@utils/appsync/schema/API";

// constants
import { ALLOCATION_TYPES } from "@utils/constants";

export interface IUserInfoState {
    email?: string;
    username?: string;
    isUserAuthorized?: boolean;
    selectedSandbox?: UserSandboxAccess;
    sandboxes?: Array<UserSandboxAccess>;
    selectedAllocationType: IAllocationType;
    isRFAUser: boolean;
    featureFlags?: object;
}

export const initialUserInfoState: IUserInfoState = {
    email: undefined,
    username: undefined,
    isUserAuthorized: false,
    selectedSandbox: undefined,
    sandboxes: [],
    selectedAllocationType: ALLOCATION_TYPES[0],
    isRFAUser: false,
    featureFlags: undefined,
};
